import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UsersFilterOptions } from './getUsersFilterOptions.types';

/**
 * Fetch available filter options for users (roles, status).
 * Endpoint: GET /users/filter-options
 */
export async function getUsersFilterOptions(
  organizationId: string
): Promise<UsersFilterOptions> {
  const { data } = await axiosInstance.get<UsersFilterOptions>(
    '/users/filter-options',
    { headers: { 'X-Organization-ID': organizationId } }
  );

  return data;
}
